import { render, staticRenderFns } from "./ChooseExtensions.vue?vue&type=template&id=7664b48b&scoped=true"
import script from "./ChooseExtensions.vue?vue&type=script&lang=js"
export * from "./ChooseExtensions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7664b48b",
  null
  
)

export default component.exports